<!-- Idea Modal Header Start-->
<div class="modal-header cluster-manager-modal">
  <h2 class="modal-title d-xs-none d-md-block">Edit Cluster</h2>
  <button
    type="button"
    (click)="close()"
    class="btn-close"
    title="Close"></button>
</div>
<!-- Idea Modal Header End-->

<!-- Idea Modal Body Start-->
<div class="modal-body idea-modal clearfix">
  <div class="row content">
    <div class="col-lg-12">
      <div class="form-group mb-3">
        <label class="form-label" for="topicsSelect">Cluster:</label>
        <select
          class="form-control"
          id="topicsSelect"
          [ngModel]="selectedCluster"
          (ngModelChange)="onSelectCluster($event)">
          <option *ngFor="let cluster of clusters" [ngValue]="cluster">
            Cluster {{ cluster['cluster_index'] + 1 }} ({{
              getTopClusterWord(cluster)
            }})
          </option>
        </select>
      </div>
      <div class="container-keywords chrome-no-repaint">
        <div *ngIf="selectedCluster" class="keywords chrome-no-repaint">
          <div
            *ngFor="let keywordObj of keywordObjects; let i = index"
            class="col-lg-3 keywordGroup">
            <div class="original-values">
              <div class="keyword-editing">
                <span class="keyword-text h3" *ngIf="!keywordObj.editing">
                  {{ getCurrentWord(keywordObj) }}
                </span>
                <input
                  *ngIf="keywordObj.editing"
                  (keyup.enter)="keywordObj.editing = false"
                  (keyup.escape)="keywordObj.editing = false"
                  [(ngModel)]="keywordObj.overrideWord"
                  class="form-control form-control-sm"
                  name="class_type" />
                <div *ngIf="keywordObj.editing" class="btn-group btn-group-sm">
                  <div
                    class="btn btn-sm btn-primary fa fa-check"
                    (click)="keywordObj.editing = false"></div>
                  <div
                    class="btn btn-sm fa fa-times"
                    (click)="keywordObj.editing = false"></div>
                </div>
                <div
                  *ngIf="!keywordObj.editing"
                  (click)="keywordObj.editing = true"
                  class="btn btn-secondary btn-sm fa fa-pencil-alt"></div>
                <div
                  *ngIf="!keywordObj.editing && isOverridenWord(keywordObj)"
                  (click)="resetOriginalKeyword(keywordObj)"
                  class="btn btn-secondary btn-sm">
                  reset
                </div>
              </div>
              <div class="image">
                <img
                  (error)="onFileNotFound($event, keywordObj)"
                  [ngClass]="{ 'file-not-found': keywordObj.fileNotFound }"
                  alt="not found"
                  (click)="editPicture(keywordObj)"
                  [src]="getCurrentImage(keywordObj)" />
                <div class="edit-buttons">
                  <div
                    *ngIf="isOverridenImage(keywordObj)"
                    (click)="resetOriginalImage(keywordObj)"
                    class="btn btn-sm btn-secondary">
                    reset image
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Idea Modal Body End-->

<div class="modal-footer">
  <div
    class="btn btn-primary"
    [ngClass]="{ disabled: requestInProgress }"
    (click)="save()">
    Save
  </div>
  <div
    class="btn btn-primary"
    [ngClass]="{ disabled: requestInProgress }"
    (click)="saveAndClose()">
    Save and Close
  </div>
  <div
    class="btn btn-secondary"
    [ngClass]="{ disabled: requestInProgress }"
    (click)="close()">
    Cancel
  </div>
</div>
